module.exports = __webpack_public_path__ + "img/logo-sarpras.dd99beaf.png";